<template>
  <v-app id="inspire" v-resize="onScreenResize">
    <v-snackbar
      v-model="snackbar"
      color="error"
      top
      :timeout="timeout"
    >{{text}} {{browser}}
      <v-btn
      text
        @click="snackbar = false"
      > {{'Close'.toUpperCase()}}
    </v-btn></v-snackbar>
    <v-snackbar
      color="info"
      :timeout="0"
      v-model="versionUpdateInfo"
      right
      top
      vertical
      class="mt-20 version-Update-popup"
    >
      CRM Updated
      <v-btn
        color="white"
        text
        @click="saveUpdateVarInCookie()"
      >
        Got it
      </v-btn>
    </v-snackbar>
    <v-navigation-drawer
      app
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
    >
    <navigation @close-menu-bar="closeMenuBar" :isMobile="isMobile"></navigation>
    </v-navigation-drawer>
    <v-navigation-drawer
      app
      v-if="!drawer"
      :mini-variant="!drawer"
      mini-variant-width="60"
      :clipped="$vuetify.breakpoint.lgAndUp"
    >
    <navigation @close-menu-bar="closeMenuBar" :isMobile="isMobile"></navigation>
    </v-navigation-drawer>
    <v-app-bar fixed clipped-left app color="primary">
      <v-app-bar-nav-icon class="ml-2" @click.stop="drawer = !drawer" color="white"></v-app-bar-nav-icon>
      <!-- <v-toolbar-title>{{ }}</v-toolbar-title> -->
      <v-spacer></v-spacer>
        <v-menu transition="fade-transition">
          <template v-slot:activator="{ on }">
            <v-avatar class="hidden-sm-and-down mr-4">
              <img src="@/assets/images/avatar.jpg" alt="avatar" v-on="on"  style="width: 45px; height: 45px">
            </v-avatar>
          </template>
          <v-list>
            <v-list-item>
              <v-list-item-title>{{loginUser}}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="logOut()">
              <v-list-item-title>Log out</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      <v-btn class="mr-4" icon @click.stop="$vuetify.theme.dark = !$vuetify.theme.dark">
        <v-icon color="white">palette</v-icon>
      </v-btn>
      <!-- <v-btn icon class="mr-4">
        <v-icon  color="white"> notifications</v-icon>
      </v-btn> -->
    </v-app-bar>
    <div class="overlay-for-right-drawer" v-if="rightDrawer" @click="rightDrawer=false">
    </div>
      <div v-if="rightDrawer" class="custome-right-dialog v-card ">
        <right-tab transition="slide-x-transition"></right-tab>
      </div>
    <v-content>
      <setting-breadcrumbs v-if="$route.path.includes('/settings')" :emitSetting="$route.name" :name="$route.meta.settingText"></setting-breadcrumbs>
      <app-main :key="$route.fullPath"></app-main>
      <loader v-if="$store.getters.showLoader" v-bind:data="$store.getters.loaderMessage"></loader>
      <snack-bar
        v-if="$store.getters.showAlert"
        v-bind:status="$store.getters.showAlert"
        v-bind:message="$store.getters.alertMessage"
        v-bind:color="$store.getters.alertColor"
      >
      </snack-bar>
      <global-address-layout v-if="$store.getters.globalAddressLayout" v-bind:status="$store.getters.globalAddressLayout" v-bind:addressDetail="$store.getters.addressDetail" v-bind:companyDetail="$store.getters.companyDetail" v-bind:contactDetail="$store.getters.contactDetail" v-bind:nearBy="$store.getters.nearBy"></global-address-layout>
    </v-content>
  </v-app>
</template>
<script>
import { setCookies, getCookies, removeCookies, setCookiesWithExpire } from '@/utils/cookies'
// import Crm from '@/api/Crm'
import AppMain from './components/appMain'
import RightTab from './components/rightTab'
import Navigation from './components/navigation'
import ErrorList from './components/errorList'
import GlobalSearch from './components/globalSearch'
import SnackBar from '@/view/components/snackBar'
import Loader from '@/view/components/loader'
import SettingBreadcrumbs from './components/settingBreadcrumbs'
export default {
  name: 'layout',
  components: {
    Navigation,
    ErrorList,
    AppMain,
    RightTab,
    Loader,
    GlobalSearch,
    SettingBreadcrumbs,
    SnackBar
  },
  data () {
    return {
      item1213: false,
      loginUser: '',
      router: '',
      staffProfileImage: '',
      versionUpdateInfo: false,
      isMobile: false,
      searchDrawer: false,
      rightDrawer: false,
      darkTheme: false,
      drawer: false,
      mobileDrawer: false,
      drawersmall: true,
      toDoPreAndTodayCount: 0,
      toDoCountObj: '',
      showMenu: false,
      x: 0,
      y: 0,
      items: [],
      isIeNotSupport: false,
      text: 'Some functionalities not work in',
      snackbar: false,
      timeout: null,
      browser: ''
    }
  },
  // data: () => ({
  //   item1213: false,
  //   loginUser: '',
  //   router: '',
  //   staffProfileImage: '',
  //   versionUpdateInfo: false,
  //   isMobile: false,
  //   searchDrawer: false,
  //   rightDrawer: false,
  //   darkTheme: false,
  //   drawer: false,
  //   mobileDrawer: false,
  //   drawersmall: true,
  //   toDoPreAndTodayCount: 0,
  //   toDoCountObj: '',
  //   showMenu: false,
  //   x: 0,
  //   y: 0,
  //   items: [],
  //   isIeNotSupport: false,
  //   text: 'Some functionalities not work in',
  //   snackbar: false,
  //   timeout: null,
  //   browser: ''
  // }),
  props: {
    source: String
  },
  created () {
    if (window.innerWidth <= 1264) {
      this.isMobile = true
      this.drawer = false
    }
    if (window.innerWidth <= 780) {
      this.drawer = false
      this.drawersmall = false
    }
  },
  mounted () {
    this.router = this.$router.options.routes
    console.log('routing..', this.$router.options.routes)
    for (let index = 0; index < this.$router.options.routes.length; index++) {
      if (this.$store.getters.isAdmin === false && this.router[index].name !== 'dashboard' && this.router[index].name !== 'filemanager') {
        this.router[index].hidden = this.CheckPermission(this.router[index].meta.permission)
      }
      if (this.$router.currentRoute.name === this.router[index].name) {
        this.router[index].meta.selected = true
      }
    }
    let authToken = getCookies('authToken')
    console.log('authToken', authToken)
    let expiryDate = getCookies('expiryDate')
    console.log('expiryDate', expiryDate)
    let today = new Date()
    if (this.$options.filters.dateFilter(today) !== this.$options.filters.dateFilter(expiryDate)) {
      // removeCookies('expiryDate')
      // setCookies('authToken', authToken)
      setCookies('expiryDate', today.setDate(today.getDate() + 3))
    }
    this.checkIsIE()
    if (localStorage._sData) {
      let staffData = JSON.parse(localStorage._sData)
      console.log('staffData', staffData)
      this.loginUser = staffData.userFirstName + ' ' + staffData.userLastName
    }
  },
  watch: {
    // darkTheme: {
    //   handler () {
    //     setCookies('DarkTheme', this.darkTheme)
    //   }
    // }
  },
  methods: {
    checkIsIE () {
      var isIE = false
      if (/MSIE 10/i.test(navigator.userAgent)) {
        // This is internet explorer 10
        // window.alert('isIE10')
        this.browser = 'Microsoft Internet Explorer'
        isIE = true
      }
      if (/MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent)) {
        // This is internet explorer 9 or 11
        window.location = 'pages/core/ie.htm'
      }
      if (/Edge\/\d./i.test(navigator.userAgent)) {
        // This is Microsoft Edge
        // window.alert('Microsoft Edge')
        this.browser = 'Microsoft Edge'
        isIE = true
      }
      // console.log('isIE', isIE)
      if (isIE === true) {
        this.isIeNotSupport = true
        this.snackbar = true
      }
    },
    onScreenResize () {
      if (window.innerWidth <= 1264) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },
    routeTo (path) {
      let router = this.$store.getters.menuList
      // console.log('router', router)
      for (let index = 0; index < router.length; index++) {
        if (router[index].hidden === false) {
          if (path === router[index].name) {
            router[index].meta.selected = true
            // console.log('router selected', router[index])
          } else {
            router[index].meta.selected = false
            // console.log('router not selected', router[index])
          }
        }
      }
      this.$router.push({name: path})
    },
    closeMenuBar: function (value) {
      if (window.innerWidth < 1260) {
        this.drawersmall = false
        this.drawer = !this.drawer
        this.mobileDrawer = !this.mobileDrawer
      }
    },
    toggleMenuBat () {
      if (window.innerWidth > 1260) {
        this.drawersmall = !this.drawersmall
      } else {
        this.drawersmall = false
        this.drawer = !this.drawer
        this.mobileDrawer = !this.mobileDrawer
      }
    },
    // toDoCount () {
    //   let start = new Date()
    //   start.setHours(0, 0, 0, 0)
    //   let end = new Date()
    //   end.setHours(23, 59, 59, 999)
    //   let todayStartDate = start.toUTCString()
    //   let todayEndDate = end.toUTCString()
    //   // console.log(todayStartDate)
    //   // console.log(todayEndDate)
    //   Crm.toDoCount(
    //     todayStartDate,
    //     todayEndDate,
    //     response => {
    //       console.log(response)
    //       this.toDoPreAndTodayCount = response.Data.previousCount + response.Data.todayCount
    //       this.toDoCountObj = response.Data
    //     },
    //     error => {
    //       console.log(error)
    //     }
    //   )
    // },
    logOut () {
      removeCookies('authToken')
      this.$store.dispatch('SetAdmin', '')
      this.$store.dispatch('SetPermission', [])
      localStorage.removeItem('_dData1')
      localStorage.removeItem('_sData')
      window.location.reload()
      // this.$router.push({name: 'login'})
    },
    show (e, type) {
      e.preventDefault()
      this.showMenu = false
      this.x = e.clientX
      this.y = e.clientY
      this.items = []
      this.items.push({title: 'Open in new tab', value: type})
      this.$nextTick(() => {
        this.showMenu = true
      })
    },
    newTab (name) {
      let routeData = this.$router.resolve({name: name})
      window.open(routeData.href, '_blank')
    },
    saveUpdateVarInCookie () {
      this.versionUpdateInfo = false
      setCookiesWithExpire('crmVersion', process.env.CRM_CURRENT_VERSION, 5000)
    }
  }
}
</script>
<style scoped>
.top-header-img{
  height: 50px;
}
.v-btn{
  text-transform: none;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/view/admin/layout/layout.vue